import React from 'react';


const Header = () => {
    return (
        <header className="header">


            <div>
                <div className="header-content">
                    {/* Logo Section */}

                    {/* Text Section */}
                    <div className="header-text">
                        <h1>राष्ट्रीय युवा मोर्चा (RYM)</h1>
                        <p>युवाओं का सशक्तिकरण, राष्ट्र निर्माण और सामाजिक-राजनीतिक बदलाव के लिए मंच</p>
                    </div>
                </div>
                <div className="logo-container">
                    <img
                        src="./brandlogo.jpeg" // Replace with the actual path to your logo
                        alt="Logo"
                        className="responsive-logo"
                    />
                </div>
            </div>
        </header>
    );
};

export default Header;
